module.exports = __webpack_public_path__ + "static/assets/56b4a8f737e99cb924374deafcac8905.svg";